import { View, Text, Image } from '@react-pdf/renderer';
import { invoiceHeaderStyle } from './style';
import { AddressDto, OrganizationWithPolicies } from '../../../commonTypes/organization.types';
import { InvoiceClientDto } from '../../../commonTypes/client.types';

type InvoiceHeaderProps = {
    invoiceNumber?: string;
    invoiceDate?: string;
    dueDate?: string;
    totalAmount: string;
    status?: string;
    organization?: OrganizationWithPolicies;
    client: InvoiceClientDto;
};

export const formatAddress = (address: AddressDto, excludeStreetLine2: boolean = false): string => {
    if (!address) return '';

    const parts = [address.streetline1, !excludeStreetLine2 ? address.streetline2 : null, [address.city, address.state].filter(Boolean).join(', ')];

    return parts.filter(Boolean).join('\n');
};

export const InvoiceHeader = ({ invoiceNumber, invoiceDate, dueDate, organization, client }: InvoiceHeaderProps) => {
    const fromAddress = organization?.address ? formatAddress(organization?.address) : '';

    const billToAddress = formatAddress({ streetline1: client?.billingStreet, city: client?.billingCity, countryId: client?.countryId }, true);

    const logoUrl = organization?.logoUrl;

    const clientRegNumberExists = !!client?.registrationNumber?.toString().trim();
    const organizationRegNumberExists = !!organization?.registrationNumber?.toString().trim();

    const clientTaxNumberExists = !!client?.taxNumber?.toString().trim();
    const organizationTaxNumberExists = !!organization?.taxNumber?.toString().trim();

    return (
        <View style={invoiceHeaderStyle.wrapper}>
            <View style={invoiceHeaderStyle.topRow}>
                <View style={invoiceHeaderStyle.invoiceSection}>
                    <Text style={invoiceHeaderStyle.invoiceLabel}>INVOICE</Text>
                    <Text style={invoiceHeaderStyle.invoiceNumber}>#{invoiceNumber}</Text>
                </View>
                {logoUrl && <Image src={logoUrl} style={invoiceHeaderStyle.logo} />}
            </View>

            <View style={invoiceHeaderStyle.sectionsRow}>
                <View style={invoiceHeaderStyle.section}>
                    <View style={invoiceHeaderStyle.dateItem}>
                        <Text style={invoiceHeaderStyle.label}>Invoice Date</Text>
                        <Text style={invoiceHeaderStyle.value}>{invoiceDate}</Text>
                    </View>
                    <View style={invoiceHeaderStyle.dateItem}>
                        <Text style={invoiceHeaderStyle.label}>Due Date</Text>
                        <Text style={invoiceHeaderStyle.value}>{dueDate}</Text>
                    </View>
                </View>

                <View style={invoiceHeaderStyle.section}>
                    <Text style={invoiceHeaderStyle.label}>From</Text>
                    <Text style={invoiceHeaderStyle.title}>{organization?.name}</Text>
                    <Text style={invoiceHeaderStyle.address}>{fromAddress}</Text>
                    {organizationRegNumberExists && (
                        <Text style={invoiceHeaderStyle.address}>
                            {organization?.registrationNumberLabel}: {organization?.registrationNumber}
                        </Text>
                    )}
                    {organizationTaxNumberExists && (
                        <Text style={invoiceHeaderStyle.address}>
                            {organization?.taxNumberLabel}: {organization?.taxNumber}
                        </Text>
                    )}
                </View>

                <View style={invoiceHeaderStyle.sectionLast}>
                    <Text style={invoiceHeaderStyle.label}>Bill To</Text>
                    <Text style={invoiceHeaderStyle.title}>{client?.name}</Text>
                    <Text style={invoiceHeaderStyle.address}>{billToAddress}</Text>
                    {clientRegNumberExists && (
                        <Text style={invoiceHeaderStyle.address}>
                            {client?.registrationNumberLabel}: {client?.registrationNumber}
                        </Text>
                    )}
                    {clientTaxNumberExists && (
                        <Text style={invoiceHeaderStyle.address}>
                            {client?.taxNumberLabel}: {client?.taxNumber}
                        </Text>
                    )}
                </View>
            </View>
        </View>
    );
};
